import { Injectable } from '@angular/core';
import moment from 'moment';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
import { NotificationCenterApi } from 'src/app/shared/apis/notification-center.api';
import { DeleteParams, QueryNoticeParams } from 'src/app/shared/interfaces/notification-center.interface';
import { LocaleService } from 'src/app/shared/service/locale.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  /**订阅是否已经全部删除 */
  isDeleteAll$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  /**订阅是否已经全部阅读 */
  isReadedAll$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  /**当top-bar 清除之后和推送事件发生的时候 主页面重新加载页面的数据*/
  reLoadData$: Subject<boolean> = new Subject<boolean>();
  constructor(
    private appService: AppService,
    private notificationApi: NotificationCenterApi,
    private localeService: LocaleService,
  ) {}

  // 获取站内信 所有信息
  getNoticeCounts() {
    this.notificationApi.getNoticeCount().subscribe(noticeCounts => {
      this.appService.noticeCounts$.next(noticeCounts);
    });
  }

  // 时间转换
  toTransferDate(timestamp: number) {
    if (typeof timestamp === 'string') return timestamp;
    return moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
  }

  /**
   * 转换成YYYY-MM-DD HH:mm:ss的时间格式
   *
   * @param timestamp
   */
  toTransferActTime(timestamp: number) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    const hours = ('0' + date.getHours()).slice(-2);
    const minutes = ('0' + date.getMinutes()).slice(-2);
    const seconds = ('0' + date.getSeconds()).slice(-2);
    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return formattedDate;
  }

  getQueryNotice(params?: QueryNoticeParams): Observable<any> {
    return this.notificationApi.getQueryNotice(params).pipe(
      map(
        x =>
          x?.data || {
            list: [],
            total: 0,
          },
      ),
      map(x => ({
        list: x.list.map((item: any) => ({
          ...item,
          title: this.localeService.brandNameReplace(item.title),
          content: this.localeService.brandNameReplace(item.content),
          sendTime: this.toTransferDate(item.sendTime),
          sendActTime: this.toTransferActTime(item.sendTime),
        })),
        total: x.total,
      })),
    );
  }

  // 获取站内信邮件
  public getNoticeList(params?: { n: number }) {
    return this.notificationApi.getNoticeList(params).pipe(
      map(
        (x: any) =>
          x?.data.map((item: any) => ({
            ...item,
            title: this.localeService.brandNameReplace(item.title),
            content: this.localeService.brandNameReplace(item.content),
            sendTime: this.toTransferDate(item.sendTime),
          })) || {
            data: [],
          },
      ),
    );
  }

  //设置已经
  readNotice(params: DeleteParams): Observable<any> {
    return this.notificationApi.readNotice(params).pipe(
      map(
        (x: any) =>
          x?.data || {
            data: false,
          },
      ),
    );
  }
  //删除
  deleteNotice(params: DeleteParams): Observable<any> {
    return this.notificationApi.deleteNotice(params).pipe(
      map(
        x =>
          x?.data || {
            data: false,
          },
      ),
    );
  }
}
